/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicPortalSettingsRpc
 */
import * as References from './PublicPortalSettingsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { restClient } from 'billing-portal-ui/js/clients/chirpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: restClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicPortalSettingsRpc#getSettings
 */
export const GET_SETTINGS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_PublicPortalSettingsRpc_getSettings';
export const GET_SETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SETTINGS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});